import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "bgt_access_token";

export function setAccessToken(token) {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
}

export function getAccessToken() {
  return localStorage.getItem(TOKEN_KEY);
}

const client = axios.create({
  baseURL: API,
  withCredentials: true,
});

client.interceptors.request.use((config) => {
  const token = getAccessToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

client.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 429) {
      err.response.data = err.response.data || {};
      err.response.data._status = 429;
    }
    return Promise.reject(err);
  }
);

const _PYDANTIC_MSG_MAP = {
  "string_too_short": "Il campo è troppo corto",
  "string_too_long": "Il campo è troppo lungo",
  "value_error": "Valore non valido",
  "missing": "Campo obbligatorio mancante",
  "int_parsing": "Deve essere un numero intero",
  "greater_than_equal": "Il valore è troppo basso",
  "less_than_equal": "Il valore è troppo alto",
};

export function formatApiError(detail, status) {
  if (status === 429) return "Troppi tentativi. Riprova tra qualche minuto.";
  if (detail == null) return "Si è verificato un errore. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    const msgs = detail
      .map((e) => {
        if (!e) return null;
        if (typeof e.msg === "string") {
          const mapped = _PYDANTIC_MSG_MAP[e.type] || e.msg;
          const field = Array.isArray(e.loc) ? e.loc.filter((x) => x !== "body").join(" → ") : "";
          return field ? `${field}: ${mapped}` : mapped;
        }
        return null;
      })
      .filter(Boolean);
    return msgs.length ? msgs.join(". ") : "Errore di validazione. Controlla i campi.";
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default client;
